import { render, staticRenderFns } from "./dashboardItem.pug?vue&type=template&id=4fa857ee&scoped=true&lang=pug&"
import script from "./dashboardItem.ts?vue&type=script&lang=ts&"
export * from "./dashboardItem.ts?vue&type=script&lang=ts&"
import style0 from "./dashboardItem.scss?vue&type=style&index=0&id=4fa857ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa857ee",
  null
  
)

export default component.exports